import { importProvidersFrom } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CodeInputModule } from 'angular-code-input';
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { deLocale, frLocale, itLocale } from 'ngx-bootstrap/locale';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

defineLocale('de-ch', deLocale);
defineLocale('fr-ch', frLocale);
defineLocale('it-ch', itLocale);

export const thirdPartyProviders = [
  importProvidersFrom(
    CodeInputModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [globalThis.location.origin + '/api'],
        sendAccessToken: true,
      },
    }),
    NgxMaskDirective,
    TranslateModule.forRoot({
      fallbackLang: 'de-CH',
    }),
    NgxExtendedPdfViewerModule,
    BsDropdownModule,
    ModalModule,
    TooltipModule,
    BsDatepickerModule,
    CollapseModule,
    TypeaheadModule,
    TabsModule,
  ),
  OAuthService,
  { provide: OAuthStorage, useValue: localStorage },
  provideNgxMask(),
];
